import script from "./WarningModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WarningModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__